import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { SipCalculatorIndex } from "@/tools/sip-calculator/pages/SipCalculatorIndex";

const PATH = "/sip-calculator";

export const Route = createFileRoute("/sip-calculator/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.sip_hub_meta_title() },
      { name: "description", content: m.sip_hub_meta_description() },
      { property: "og:title", content: m.sip_hub_meta_title() },
      { property: "og:description", content: m.sip_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.sip_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.sip_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
    ],
  }),
  component: SipCalculatorIndex,
});
